import loadable from '@loadable/component'

export default [
  // {
  //   path: '/code/feedback',
  //   exact: true,
  //   component: loadable(
  //     () => import(/* webpackChunkName: "page-code-Feedback" */ '~/pages/r_code/Feedback')
  //   ),
  // },
  {
    path: '/code/faq',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-FAQ" */ '~/pages/r_code/Feedback/FAQ'
        )
    ),
  },
  {
    path: '/code/faq/:id',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-FAQDetail" */ '~/pages/r_code/Feedback/FAQDetail'
        )
    ),
  },
  {
    path: '/code/feedback',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-FeedbackReportScenes" */ '~/pages/r_code/Feedback/ReportScenes'
        )
    ),
  },
  {
    path: '/code/feedback/room',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-FeedbackReportScenes" */ '~/pages/r_code/Feedback/ReportScenes'
        )
    ),
  },
  {
    path: '/code/feedback/reportcontent',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-FeedbackReportContent" */ '~/pages/r_code/Feedback/ReportContent'
        )
    ),
  },
  {
    path: '/code/feedback/servicecenter',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-FeedbackServiceCenter" */ '~/pages/r_code/Feedback/ServiceCenter'
        )
    ),
  },
  {
    path: '/code/feedback/servicecenter/:type',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-FeedbackServiceCenter" */ '~/pages/r_code/Feedback/ServiceCenter'
        )
    ),
  },
  {
    path: '/code/feedback/illegaldetail',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-FeedbackIllegalDetail" */ '~/pages/r_code/Feedback/IllegalDetail'
        )
    ),
  },
  {
    path: '/code/feedback/punishdetail',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-FeedbackPunishDetail" */ '~/pages/r_code/Feedback/PunishDetail'
        )
    ),
  },
]
